import { createContext } from "react";

export const ApiContext = createContext("https://restapi.fr/api/recipes");
